import ConsortiumApi, { ConsortiumRegistrationFiles } from "api/wenImmo/ConsortiumApi";
import ConsortiumPageResponseResource from "common/resources/Consortium/ConsortiumPageResponseResource";
import ConsortiumRegistrationRequestResource from "common/resources/Consortium/ConsortiumRegistrationRequestResource";
import { container, singleton } from "tsyringe";
import toValidationError from "utils/toValidationError";

@singleton()
export default class ConsortiumService {
	private readonly api = container.resolve(ConsortiumApi);

	public async getPage() {
		return this.api
			.getPage()
			.then((page) => ConsortiumPageResponseResource.hydrate<ConsortiumPageResponseResource>(page))
			.catch(toValidationError);
	}

	public async subscribe(request: ConsortiumRegistrationRequestResource, files: ConsortiumRegistrationFiles) {
		return this.api
			.subscribe(request, files)
			.then((page) => ConsortiumPageResponseResource.hydrate<ConsortiumPageResponseResource>(page))
			.catch(toValidationError);
	}

	public async refresh() {
		return this.api
			.refresh()
			.then((page) => ConsortiumPageResponseResource.hydrate<ConsortiumPageResponseResource>(page))
			.catch(toValidationError);
	}
}
